import * as uuid from "uuid";

export const sessionId = uuid.v4();
